module.exports = __webpack_public_path__ + "static/preview-skillfactory-d60738ae7765ece7a58e796a9123daca.png";